import securityReducer, { persistedKeys } from './reducers/security.js';

export default {
    security: {
        reducer: securityReducer,
        persist: { keys: persistedKeys },
    },
};
